import { differenceInCalendarDays, parseISO } from 'date-fns';

const getWarrantyRemainingPercent = (purchasedAt: string, warrantyUntil: string, today = new Date()): number => {
    const expiry = parseISO(warrantyUntil);
    const totalDays = differenceInCalendarDays(expiry, parseISO(purchasedAt));
    const remainingDays = differenceInCalendarDays(expiry, today);

    if (!Number.isFinite(totalDays) || !Number.isFinite(remainingDays) || totalDays <= 0) {
        return 0;
    }

    return Math.min(100, Math.max(0, remainingDays / totalDays * 100));
};

export default getWarrantyRemainingPercent;
